<div class="audio-modal-container">

    <div class="audio-modal-container__header">
        @if(isMuted()){
            <icon-volume-off (click)="toggleMute()" />
        }
        @else {
            <icon-volume-on (click)="toggleMute()" />
        }
        <icon-minimize (click)="dismissModal()" />
    </div>

    <div class="audio-modal-container__body">
        <div class="audio-modal-container__body__logo">
            <icon-no-cover />
        </div>

        <!-- <span class="audio-modal-container__body__title"> Título de la audioguía </span>

        <span class="audio-modal-container__body__name"> Nombre del recurso </span>

        <span class="audio-modal-container__body__description">
            Lorem ipsum dolor sit amet consectetur adipiscing elit, porta neque tempus habitasse praesent. Proin torquent nisl cursus nascetur euismod vehicula montes lacinia, varius eros augue curae tristique congue curabitur sapien, tempus auctor lobortis sociosqu mollis rutrum tortor. Sodales eleifend magna libero neque iaculis vivamus nam accumsan, felis praesent habitasse cursus integer nisl imperdiet, dui pulvinar semper euismod dictum enim mattis.
        </span> -->
    </div>

    <div class="audio-modal-container__timeline">
        <span>{{playingDurationString()}}</span>
        <mat-slider [min]="0" [max]="duration()" step="0.1">
            <input matSliderThumb [value]="currentTime()" (valueChange)="changeValue($event)">
        </mat-slider>
        <span>{{durationString()}}</span>
    </div>

    <div class="audio-modal-container__controls">
        <icon-backward (click)="handleBackward()" />
        @if(isPlaying()){
            <icon-pause (click)="handlePlayPause()"/>
        }
        @else {
            <icon-play (click)="handlePlayPause()" />
        }
        <icon-forward (click)="handleForward()" />
    </div>

</div>